<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">{{newLender ? 'Add Lender' : 'Edit Lender'}}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="lenderDetails" autocomplete="off">

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Name</label>
        <input class="form-control" maxlength="75" formControlName="name">
      </div>
      <div class="col-sm-6" *ngIf="!newLender">
        <label class="form-label fw-semibold">Active</label>
        <app-yes-no-form-toggle class="d-block" formControlName="isActive"></app-yes-no-form-toggle>
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button *ngIf="!updatingLender" type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">Cancel</button>

  <ng-container *ngIf="!newLender">
    <button *ngIf="updatingLender" type="button" class="btn btn-success" disabled>
      <span class="spinner-border spinner-border-sm" role="status"></span>
      Updating...
    </button>
    <button *ngIf="!updatingLender" type="button" class="btn btn-success"
      [disabled]="lenderDetails.invalid" (click)="saveLender()">Update</button>
  </ng-container>

  <ng-container *ngIf="newLender">
    <button *ngIf="updatingLender" type="button" class="btn btn-success" disabled>
      <span class="spinner-border spinner-border-sm" role="status"></span>
      Saving...
    </button>
    <button type="button" class="btn btn-success" *ngIf="!updatingLender" 
      [disabled]="lenderDetails.invalid" (click)="addLender()">Save</button>
  </ng-container>
</div>